<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 512 512">
    <title>{{ title }}</title>
    <g :fill="fill">
      <path d="M478.26,239.76H264.37a70.81,70.81,0,0,0-137.59,0H33.12a16.74,16.74,0,1,0,0,33.48h93.66a70.82,70.82,0,0,0,137.59,0H478.26a16.74,16.74,0,0,0,0-33.48Z"/>
      <path d="M33.12,110.88h205a70.75,70.75,0,0,0,137.49,0h102.7a16.74,16.74,0,1,0,0-33.48H375.56A70.82,70.82,0,0,0,238,77.4H33.12a16.74,16.74,0,1,0,0,33.48Z"/>
      <path d="M478.26,401.14H375.56a70.81,70.81,0,0,0-137.59,0H33a16.74,16.74,0,1,0,0,33.48H238.07a70.75,70.75,0,0,0,137.49,0h102.7a16.74,16.74,0,0,0,0-33.48Z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Comparateur",
  props: {
    title: {
      type: String,
      default: 'Ajouter au comparateur',
    },
    size: {
      type: Number,
      default: 48,
    },
    fill: {
      type: String,
      default: 'inherit',
    },
  },
}
</script>

<style scoped lang="scss">

</style>
